// Toggle header background when menu opens
(function() {
  'use strict';
  
  function init() {
    const headerWrapper = document.querySelector('.header-wrapper, sticky-header.header-wrapper');
    const announcementBar = document.querySelector('.utility-bar, .announcement-bar');
    
    if (!headerWrapper) return;
    
    // Desktop dropdown menu (ソックス)
    const desktopMenuDetails = document.querySelectorAll('header-menu details');
    
    desktopMenuDetails.forEach(details => {
      details.addEventListener('toggle', function() {
        if (this.open) {
          // Menu opened - add scrolled class
          headerWrapper.classList.add('scrolled');
          if (announcementBar) {
            announcementBar.classList.add('scrolled');
          }
          
          // Add scrolled class to all header children
          const headerElements = headerWrapper.querySelectorAll('*');
          headerElements.forEach(el => el.classList.add('scrolled'));
          
          if (announcementBar) {
            const announcementElements = announcementBar.querySelectorAll('*');
            announcementElements.forEach(el => el.classList.add('scrolled'));
          }
        } else {
          // Menu closed - remove scrolled class only if not actually scrolled
          if (window.scrollY === 0) {
            headerWrapper.classList.remove('scrolled');
            if (announcementBar) {
              announcementBar.classList.remove('scrolled');
            }
            
            // Remove scrolled class from all header children
            const headerElements = headerWrapper.querySelectorAll('*');
            headerElements.forEach(el => el.classList.remove('scrolled'));
            
            if (announcementBar) {
              const announcementElements = announcementBar.querySelectorAll('*');
              announcementElements.forEach(el => el.classList.remove('scrolled'));
            }
          }
        }
      });
    });
    
    // Mobile menu drawer
    const mobileMenuDetails = document.querySelector('#Details-menu-drawer-container');
    
    if (mobileMenuDetails) {
      mobileMenuDetails.addEventListener('toggle', function() {
        if (this.open) {
          // Menu opened - add scrolled class
          headerWrapper.classList.add('scrolled');
          if (announcementBar) {
            announcementBar.classList.add('scrolled');
          }
          
          // Add scrolled class to all header children
          const headerElements = headerWrapper.querySelectorAll('*');
          headerElements.forEach(el => el.classList.add('scrolled'));
          
          if (announcementBar) {
            const announcementElements = announcementBar.querySelectorAll('*');
            announcementElements.forEach(el => el.classList.add('scrolled'));
          }
        } else {
          // Menu closed - remove scrolled class only if not actually scrolled
          if (window.scrollY === 0) {
            headerWrapper.classList.remove('scrolled');
            if (announcementBar) {
              announcementBar.classList.remove('scrolled');
            }
            
            // Remove scrolled class from all header children
            const headerElements = headerWrapper.querySelectorAll('*');
            headerElements.forEach(el => el.classList.remove('scrolled'));
            
            if (announcementBar) {
              const announcementElements = announcementBar.querySelectorAll('*');
              announcementElements.forEach(el => el.classList.remove('scrolled'));
            }
          }
        }
      });
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
